/* tslint:disable */
/* eslint-disable */
/**
 * Navitia API - SNCF
 * Complete API documentation for Navitia/SNCF public transportation API. Based on https://doc.navitia.io
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '@/client/configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '@/client/common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '@/client/base';
// @ts-ignore
import type { DeparturesResponse } from '@/client/models';
/**
 * DeparturesApi - axios parameter creator
 */
export const DeparturesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get next departures from a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasIdDeparturesGet: async (coverage: string, id: string, datetime?: string, count?: number, depth?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'coverage' is not null or undefined
            assertParamExists('coverageCoverageStopAreasIdDeparturesGet', 'coverage', coverage)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('coverageCoverageStopAreasIdDeparturesGet', 'id', id)
            const localVarPath = `/coverage/{coverage}/stop_areas/{id}/departures`
                .replace(`{${"coverage"}}`, encodeURIComponent(String(coverage)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (datetime !== undefined) {
                localVarQueryParameter['datetime'] = datetime;
            }

            if (count !== undefined) {
                localVarQueryParameter['count'] = count;
            }

            if (depth !== undefined) {
                localVarQueryParameter['depth'] = depth;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeparturesApi - functional programming interface
 */
export const DeparturesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeparturesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get next departures from a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async coverageCoverageStopAreasIdDeparturesGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeparturesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.coverageCoverageStopAreasIdDeparturesGet(coverage, id, datetime, count, depth, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeparturesApi.coverageCoverageStopAreasIdDeparturesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeparturesApi - factory interface
 */
export const DeparturesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeparturesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get next departures from a stop area
         * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
         * @param {string} id 
         * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
         * @param {number} [count] Number of results to return
         * @param {number} [depth] Depth of detail in response
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        coverageCoverageStopAreasIdDeparturesGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<DeparturesResponse> {
            return localVarFp.coverageCoverageStopAreasIdDeparturesGet(coverage, id, datetime, count, depth, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeparturesApi - interface
 */
export interface DeparturesApiInterface {
    /**
     * 
     * @summary Get next departures from a stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id 
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    coverageCoverageStopAreasIdDeparturesGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig): AxiosPromise<DeparturesResponse>;

}

/**
 * DeparturesApi - object-oriented interface
 */
export class DeparturesApi extends BaseAPI implements DeparturesApiInterface {
    /**
     * 
     * @summary Get next departures from a stop area
     * @param {string} coverage Coverage area (e.g., \&#39;sncf\&#39;)
     * @param {string} id 
     * @param {string} [datetime] Date and time in format YYYYMMDDTHHmmss
     * @param {number} [count] Number of results to return
     * @param {number} [depth] Depth of detail in response
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public coverageCoverageStopAreasIdDeparturesGet(coverage: string, id: string, datetime?: string, count?: number, depth?: number, options?: RawAxiosRequestConfig) {
        return DeparturesApiFp(this.configuration).coverageCoverageStopAreasIdDeparturesGet(coverage, id, datetime, count, depth, options).then((request) => request(this.axios, this.basePath));
    }
}

